import AbstractComponent from './AbstractComponent';

export default class Video extends AbstractComponent {
  /**
   * The HTML element of the header.
   */
  private $video: HTMLElement;

  /**
   * Initializes the header.
   */
  public initialize(): void {
    this.$video = document.querySelector('.possibilities__video');

    this.$video.addEventListener('click', () => this.showYoutube());
  }

  private showYoutube(): void {
    this.$video.innerHTML = '<iframe allowfullscreen frameborder="0" src="' + this.$video.dataset.youtubeUrl + '"></iframe>';
  }
}
